module.exports = __webpack_public_path__ + "assets/img/logo_no_name.cc25340b.svg";